export const LOAD_WEB3_MODAL = 'LOAD_WEB3_MODAL';
export const UNLOAD_WEB3_MODAL = 'UNLOAD_WEB3_MODAL';
export const UPDATE_LOADING = 'UPDATE_LOADING';